import {
    CLEAR_SEARCH_FREELANCERS, EMPTY_FREELANCERS,
    SEARCH_FREELANCERS, SEARCH_FREELANCERS_SUCCESS, SEARCH_FREELANCERS_FAILURE,
    SET_FREELANCERS_SEARCH_FIELD, SET_FREELANCERS_FILTERS
} from "./constants";

import Request from 'utils/request';
import { PATHS } from 'utils/paths';

export const clearSearchFreelancers = () => ({
    type: CLEAR_SEARCH_FREELANCERS
});

export const emptyFreelancers = () => ({
    type: EMPTY_FREELANCERS
});

export const searchFreelancers = () => ({
    type: SEARCH_FREELANCERS
});

export const searchFreelancersSuccess = (data) => ({
    type: SEARCH_FREELANCERS_SUCCESS,
    data
});

export const searchFreelancersFailure = (error) => ({
    type: SEARCH_FREELANCERS_FAILURE,
    error
});

export const setFreelancersSearchField = (data) => ({
    type: SET_FREELANCERS_SEARCH_FIELD,
    data
});

export const setFreelancersFilters = (data) => ({
    type: SET_FREELANCERS_FILTERS,
    data
});



export const getSearchForFreelancers = () => (dispatch, getStore) => {
    dispatch(searchFreelancers());

    let searchTerm = getStore().freelancers.searchTerm;
    let filters = getStore().freelancers.filters;

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.freelancer.search(searchTerm, filters.specializationIds.join(','), filters.experienceIds.join(',')))
        .then((response) => {
            let results = response.data.data;
            dispatch(searchFreelancersSuccess(results));
            return response;
        })
        .catch((error) => {
            console.log('getSearchForFreelancers error', error, error.response);
            error.friendlyMessage = 'There was an issue performing this search.  Please try again.';
            dispatch(searchFreelancersFailure(error));
            throw error;
        });
}



// WEBPACK FOOTER //
// ./src/containers/Freelancers/store/actions.js